export default "__VITE_ASSET__B916RM76__"